"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TbTable = exports.getColumnStyle = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var react_waypoint_1 = require("react-waypoint");
var TbTableRows_1 = require("./TbTableRows");
var Spinner_1 = __importDefault(require("./Spinner"));
var getColumnStyle = function (column, header) {
    var _a;
    if (header === void 0) { header = false; }
    return {
        minWidth: column.width,
        width: column.width,
        maxWidth: column.width,
        fontFamily: header ? 'Montserrat-Bold' : (_a = column.fontFamily) !== null && _a !== void 0 ? _a : 'Roboto-Mono'
    };
};
exports.getColumnStyle = getColumnStyle;
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        root: {
            overflow: 'hidden',
            border: 'none',
            borderRadius: 0,
            flexGrow: 1,
            flexBasis: '100%',
            display: 'flex'
        },
        tableRow: {
            cursor: 'pointer'
        },
        tableCell: {
            padding: '8px 4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            '&:first-child': {
                paddingLeft: 32,
                fontFamily: 'Montserrat-Bold',
                fontSize: 16,
                lineHeigth: 1.25
            }
        },
        tableContainer: {
            maxHeight: '100%',
            overflowY: 'scroll'
        },
        tableHeader: {
            padding: '8px 4px',
            '&:first-child': {
                paddingLeft: 32
            },
            backgroundColor: function (_a) {
                var color = _a.color;
                return color;
            }
        },
        tableHeaderCell: {
            color: 'white !important',
            whiteSpace: 'nowrap',
            backgroundColor: 'transparent',
            fontFamily: 'Montserrat-Bold',
            fontSize: 16,
            lineHeigth: 1.25
        },
        sortIcon: {
            color: 'white !important'
        }
    });
});
var TbTable = function (_a) {
    var columns = _a.columns, rows = _a.rows, color = _a.color, params = _a.params, onSortClick = _a.onSortClick, loading = _a.loading, onScrollToEnd = _a.onScrollToEnd, onClickRow = _a.onClickRow, valueMapper = _a.valueMapper;
    var sortOrder = params.sortOrder;
    var sortKey = params.sortBy;
    var classes = useStyles({ color: color });
    var handleSortClick = function (column, e) {
        var currentlyActive = column.key === sortKey;
        var reversedOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        var order = currentlyActive ? reversedOrder : 'asc';
        onSortClick === null || onSortClick === void 0 ? void 0 : onSortClick(column.key, order);
    };
    return (react_1.default.createElement(core_1.Paper, { className: classes.root },
        react_1.default.createElement(core_1.TableContainer, { className: classes.tableContainer, "aria-label": 'Table Container' },
            react_1.default.createElement(core_1.Table, { stickyHeader: true, "aria-label": 'Data Table' },
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null, columns.map(function (column) { return (react_1.default.createElement(core_1.TableCell, { style: __assign(__assign({}, (0, exports.getColumnStyle)(column, true)), { pointerEvents: column.disableSort ? 'none' : 'all' }), className: classes.tableHeader, key: "headerrow_column-" + column.key },
                        react_1.default.createElement(core_1.TableSortLabel, { classes: {
                                root: classes.tableHeaderCell,
                                icon: classes.sortIcon
                            }, active: column.key === sortKey, direction: column.key === sortKey ? sortOrder : undefined, onClick: function (e) { return handleSortClick(column, e); }, "aria-label": 'Sort ' + column.headerName }, column.headerName))); }))),
                react_1.default.createElement(core_1.TableBody, { "aria-label": 'Table Body' },
                    rows && rows.length > 0 && (react_1.default.createElement(TbTableRows_1.TbTableRows, __assign({}, {
                        valueMapper: valueMapper,
                        columns: columns,
                        color: color,
                        rows: rows,
                        params: params,
                        onClickRow: onClickRow
                    }))),
                    react_1.default.createElement(core_1.TableRow, { key: 'loading-row' }, !loading && (react_1.default.createElement("td", null,
                        react_1.default.createElement(react_waypoint_1.Waypoint, { bottomOffset: -600, onEnter: onScrollToEnd })))),
                    loading ? (react_1.default.createElement(core_1.TableRow, { key: 'last-row' },
                        react_1.default.createElement("td", { colSpan: columns.length },
                            react_1.default.createElement("span", { style: {
                                    paddingLeft: '50vw'
                                } },
                                react_1.default.createElement(Spinner_1.default, { "aria-label": 'Loading Spinner', color: color, style: {
                                        marginLeft: -25,
                                        marginTop: 10,
                                        marginBottom: 10
                                    } }))))) : null)))));
};
exports.TbTable = TbTable;
//# sourceMappingURL=TbTable.js.map